import React from "react";

import PracticeResult from "./PracticeResult/PracticeResult";

const PracticeResults = (props) => {
    return props.practices.map((practice) => {
            return <PracticeResult key={practice.id} practice={practice} />
        });
}

export default PracticeResults;